import {
    ButtonType,
    ButtonWidget,
    InteractionState,
    PopoverInstance,
    PopoverWidget,
    PopoverWidth,
    TextLinkKind,
    TextLinkWidget
  } from '@tableau/widgets';
  import * as React from 'react';

  import { imgPath } from '~src/commonInfra/utils/ImgUrl';
  import { SpaceHeaderStyles } from '~src/spacesPlatform/components/header/SpaceHeaderStyles';
  const ICON_PATH = imgPath('data_prep_info.svg');
  const ACTIVE_ICON_PATH = imgPath('data_prep_info_active.svg');

  const getDeprecatedInfoButtonContent = (state: InteractionState): JSX.Element => {
    const showActiveIcon = state.hover || state.active || state.focus;
    return (
      <div className={SpaceHeaderStyles.InfoDeprecatedContent}>
        <img
          className={SpaceHeaderStyles.InfoDetailImage}
          src={showActiveIcon ? ACTIVE_ICON_PATH : ICON_PATH}
          alt=""
        />
      </div>
    );
  };

  export interface DeprecatedInfoButtonProps {
    readonly testId: string;
    readonly onClick: () => void;
    readonly pre_link: string;
    readonly link: string;
    readonly title: string;
    readonly link_descriptor: string;
  }

  export function DeprecatedInfoButton(props: DeprecatedInfoButtonProps) {

    const popoverInstance = React.useRef<PopoverInstance>(null);
    const [isValueChecked, setIsValueChecked] = React.useState<boolean>(false);
    return (
        <PopoverWidget
        aria-describedby='popoverDescription'
        placement='right-end'
        popoverContent={<form>
            <p id='popoverDescription'>{props.pre_link}
            <TextLinkWidget href={props.link} kind={TextLinkKind.Standard} testId='deprecateLink'>{props.link_descriptor}</TextLinkWidget></p>
        </form>}
        ref={popoverInstance}
        showTitleBar
        title={props.title}
        triggerElement={<ButtonWidget
            buttonType={ButtonType.IconOutline}
            getContent={getDeprecatedInfoButtonContent}
            />}
        width={425 as PopoverWidth}
        />
    );
  }